import { EASY_ARCHITECT_STATE } from '@easy-architect/app/constants/easy-architect-state.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const EASY_ARCHITECT_MODULE_STATE: Ng2StateDeclaration = {
  name: `${EASY_ARCHITECT_STATE.EASY_ARCHITECT}.**`,
  url: '/easy-architect',
  loadChildren: () => import('@easy-architect/app/easy-architect.module').then((m) => m.EasyArchitectModule),
};
export const APP_STATES = [EASY_ARCHITECT_MODULE_STATE];
